<template>
  <px-select-enum
    dense
    multiple
    chips
    deletable-chips
    small-chips
    class="rounded-tag-small required"
    v-bind="$attrs"
    @blur="onBlur"
    :items="urgencias"
    v-model="localValue"/>
</template>

<script>
import { UrgenciaRequisicao } from 'px-business-components';

export default {
  props: {
    value: Array,
  },
  data() {
    return {
      urgencias: UrgenciaRequisicao.values,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
};
</script>
